import { VasAppFacade } from "../vas-app-facade.service";
import { JobStatus } from "../../business-objects/job-status/job-status.model";
import { Observable } from "rxjs/Observable";
import { Transition } from "../../business-objects/transition/transition.model";
import { zip } from "rxjs/observable/zip";
import { isInArray } from "../../../core/util/is-in-array";
import { Job } from "../../business-objects/job/job.model";

export class JobStatusTransitionService {

    constructor(protected appFacade: VasAppFacade) {

    }

    protected get jobStatuses$(): Observable<Array<JobStatus>> {
        return this.appFacade.objects.jobStatus.store
            .getAll()
            .map(list => list.sort((a, b) => a.sequence - b.sequence));
    }

    protected get transitions$(): Observable<Array<Transition>> {
        return this.appFacade.objects.transition.store
            .getAll();
    }

    /**
     * This function will return the list of job statuses that can be transitioned to using the job status id as the
     * starting point
     */
    getJobStatuses(jobStatusId: string): Observable<Array<JobStatus>> {

        return this.appFacade.objects.account.store.getActive()
            .switchMap(account => {
                if (!account || !account.workflowEnabled) {
                    return this.jobStatuses$;
                }

                return zip(this.jobStatuses$.take(1), this.transitions$.take(1))
                    .map(([jobStatuses, transitions]) => {

                        return transitions
                            .filter(t => {

                                if (!jobStatusId) {
                                    return t.fromStatuses.length === 0;
                                } else {
                                    return isInArray(jobStatusId, t.fromStatuses);
                                }
                            })
                            .map(transition => jobStatuses.find(js => js.id === transition.jobStatus))
                            .filter(j => !!j);
                    });
            });
    }

    updateJobStatus(job: Job, jobStatus: string): void {

        if (!job.id) {
            return;
        }

        job = new Job({
            ...job,
            jobStatus
        });

        this.appFacade.objects.job.store.update(job);
    }
}



// WEBPACK FOOTER //
// ./src/vas/services/work-flow/job-status-transition.service.ts